<template>
  <div>
    <div
      style="left: 0"
      class="carousel-action-left"
    >
      <v-btn
        fab
        dark
        small
        class="arrow-left"
        @click="carousel('left')"
      >
        <v-icon
          x-large
          color="white"
        >
          mdi-chevron-left
        </v-icon>
      </v-btn>
    </div>
    <div
      style="right: 0"
      class="carousel-action-right"
    >
      <v-btn
        fab
        small
        dark
        class="arrow-right"
        @click="carousel('right')"
      >
        <v-icon
          x-large
          color="white"
        >
          mdi-chevron-right
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    carousel: {
      type: Function,
      default: () => {},
    },
  },
});

</script>

<style lang="scss">

.arrow-left,
.arrow-right {
  font-size: 20px;
  color: #B3B3B3;
  transition: all 600ms ease-in-out;
  cursor: pointer;
  border: none;
  padding: 1.5rem;
}

.carousel-action-left,
.carousel-action-right {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  opacity: 0.3;
  z-index: 9999;
}

</style>
